const norm = (n) => {
  let s = (n || "").trim().toLowerCase();
  if (s.endsWith("es") && s.length > 4) s = s.slice(0, -2);
  else if (s.endsWith("s") && s.length > 3) s = s.slice(0, -1);
  return s;
};

export const matches = (veg, names) => {
  const n = norm(veg.name);
  return (names || []).some((x) => {
    const b = norm(x);
    return b && (n === b || n.includes(b) || b.includes(n));
  });
};

export const inPot = (bed, c, r) => {
  if (bed.type !== "container") return true;
  const R = Math.max(bed.cols, bed.rows) / 2;
  return Math.hypot(c + 0.5 - bed.cols / 2, r + 0.5 - bed.rows / 2) <= R;
};

export const gapCells = (veg, cellSize, unit) => {
  const sp = unit === "imperial" ? veg.spacing_cm / 2.54 : veg.spacing_cm;
  return sp ? Math.max(0, Math.ceil(sp / cellSize) - 1) : 0;
};

// Returns { spacing, companion, good, crowded:Set<"c-r"> } for one bed.
export function checkBed(bed, vegBySlug, cellSize, unit) {
  const pls = (bed.placements || []).filter((p) => vegBySlug[p.slug]);
  const spacing = new Map();
  const companion = new Map();
  const crowded = new Set();
  let good = 0;
  for (let i = 0; i < pls.length; i++) {
    for (let j = i + 1; j < pls.length; j++) {
      const a = pls[i], b = pls[j];
      const va = vegBySlug[a.slug], vb = vegBySlug[b.slug];
      const d = Math.max(Math.abs(a.col - b.col), Math.abs(a.row - b.row));
      if (bed.type !== "tray") {
        const need = Math.max(gapCells(va, cellSize, unit), gapCells(vb, cellSize, unit));
        if (d <= need) {
          crowded.add(`${a.col}-${a.row}`); crowded.add(`${b.col}-${b.row}`);
          const big = gapCells(va, cellSize, unit) >= gapCells(vb, cellSize, unit) ? va : vb;
          spacing.set(big.slug, `${big.name} needs ~${big.spacing_cm}cm spacing — some plants are too close. Leave ${need} empty square${need > 1 ? "s" : ""} around each.`);
        }
      }
      if (d === 1) {
        if (matches(vb, va.companions_bad) || matches(va, vb.companions_bad)) {
          crowded.add(`${a.col}-${a.row}`); crowded.add(`${b.col}-${b.row}`);
          const key = [va.slug, vb.slug].sort().join("|");
          companion.set(key, `${va.name} and ${vb.name} are poor companions — move them apart.`);
        } else if (matches(vb, va.companions_good) || matches(va, vb.companions_good)) {
          good += 1;
        }
      }
    }
  }
  return { spacing: [...spacing.values()], companion: [...companion.values()], good, crowded };
}

export const isBad = (a, b) => matches(b, a.companions_bad) || matches(a, b.companions_bad);
export const isGood = (a, b) => !isBad(a, b) && (matches(b, a.companions_good) || matches(a, b.companions_good));

// Good/bad neighbours for a crop from the catalog.
export function companionsFor(veg, catalog) {
  const others = catalog.filter((v) => v.slug !== veg.slug);
  return { good: others.filter((v) => isGood(veg, v)), bad: others.filter((v) => isBad(veg, v)) };
}

// "bad" | "good" | null for placing `veg` at c,r given a lookup of neighbour vegs.
export function neighbourTint(veg, c, r, vegAt) {
  let good = false;
  for (let dc = -1; dc <= 1; dc++) for (let dr = -1; dr <= 1; dr++) {
    if (!dc && !dr) continue;
    const n = vegAt(c + dc, r + dr);
    if (!n) continue;
    if (isBad(veg, n)) return "bad";
    if (isGood(veg, n)) good = true;
  }
  return good ? "good" : null;
}
